import _styled from "styled-components";
import { circularImageIcon, rectangularImageIcon, textLengthMap } from './skeleton-loading.constants';
import { SkeletonPhotoBorderedIcon, SkeletonPhotoIcon } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var loadingText = /*#__PURE__*/_jsx("span", {
  className: "sr-only",
  children: "Loading..."
});
export var SkeletonParagraphLoading = function SkeletonParagraphLoading() {
  return /*#__PURE__*/_jsx(ParagraphLoaderWrapper, {
    children: /*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "medium"
    })
  });
};
export var SkeletonRectangularImageLoading = function SkeletonRectangularImageLoading(_ref) {
  var isIcon = _ref.isIcon;
  return isIcon ? /*#__PURE__*/_jsx(Rectangle, {
    children: rectangularImageIcon
  }) : /*#__PURE__*/_jsx(Rectangle, {});
};
export var SkeletonCircularImageLoading = function SkeletonCircularImageLoading() {
  return circularImageIcon;
};
export var SkeletonCombinationCardLoading = function SkeletonCombinationCardLoading() {
  return /*#__PURE__*/_jsxs(CardLoaderWrapper, {
    children: [/*#__PURE__*/_jsx(SkeletonRectangularImageLoading, {
      isIcon: true
    }), /*#__PURE__*/_jsx(SkeletonParagraphLoading, {})]
  });
};
export var SkeletonMapDetailLoader = function SkeletonMapDetailLoader() {
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    role: "status",
    children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(SkeletonPhotoIcon, {}), /*#__PURE__*/_jsx(_StyledSkeletonPhotoBorderedIcon, {})]
    }), /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(_StyledDiv4, {}), /*#__PURE__*/_jsx(_StyledDiv5, {}), /*#__PURE__*/_jsx(_StyledDiv6, {}), /*#__PURE__*/_jsxs(_StyledDiv7, {
        children: [/*#__PURE__*/_jsx(_StyledDiv8, {}), /*#__PURE__*/_jsx(_StyledDiv9, {})]
      })]
    })]
  });
};
export var SkeletonJobPositionCardLoader = function SkeletonJobPositionCardLoader() {
  return /*#__PURE__*/_jsxs(_StyledDiv10, {
    role: "status",
    children: [/*#__PURE__*/_jsxs(_StyledDiv11, {
      children: [/*#__PURE__*/_jsx(_StyledSkeletonPhotoBorderedIcon2, {}), /*#__PURE__*/_jsxs(_StyledDiv12, {
        children: [/*#__PURE__*/_jsx(_StyledDiv13, {}), /*#__PURE__*/_jsx(_StyledDiv14, {})]
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv15, {
      children: [/*#__PURE__*/_jsx(_StyledDiv16, {}), /*#__PURE__*/_jsx(_StyledDiv17, {}), /*#__PURE__*/_jsxs(_StyledDiv18, {
        children: [/*#__PURE__*/_jsx(_StyledDiv19, {}), /*#__PURE__*/_jsx(_StyledDiv20, {}), /*#__PURE__*/_jsx(_StyledDiv21, {})]
      }), /*#__PURE__*/_jsx(_StyledDiv22, {})]
    })]
  });
};
export var SkeletonEmployerCardLoading = function SkeletonEmployerCardLoading() {
  return /*#__PURE__*/_jsxs(_StyledDiv23, {
    role: "status",
    children: [/*#__PURE__*/_jsx(_StyledDiv24, {
      children: /*#__PURE__*/_jsxs(_StyledDiv25, {
        children: [/*#__PURE__*/_jsx(_StyledSkeletonPhotoBorderedIcon3, {}), /*#__PURE__*/_jsx(SkeletonTextLoading, {
          width: "small"
        })]
      })
    }), /*#__PURE__*/_jsxs(_StyledDiv26, {
      children: [/*#__PURE__*/_jsx(SkeletonTextLoading, {
        width: "small"
      }), /*#__PURE__*/_jsx(SkeletonTextLoading, {
        width: "small"
      })]
    }), /*#__PURE__*/_jsx(_StyledDiv27, {
      children: /*#__PURE__*/_jsx(SkeletonTextLoading, {
        width: "medium"
      })
    })]
  });
};
export var SkeletonEmployerCardListLoading = function SkeletonEmployerCardListLoading() {
  return /*#__PURE__*/_jsxs(_StyledDiv28, {
    children: [/*#__PURE__*/_jsx(SkeletonEmployerCardLoading, {}), /*#__PURE__*/_jsx(SkeletonEmployerCardLoading, {})]
  });
};
export var SkeletonInputLoading = function SkeletonInputLoading() {
  return /*#__PURE__*/_jsx(_StyledDiv29, {});
};
export var SkeletonTextLoading = /*#__PURE__*/_styled.div.withConfig({
  displayName: "skeleton-loadingcomponents__SkeletonTextLoading",
  componentId: "sc-13h7lj6-0"
})(["", " ", ""], {
  "marginBottom": "1rem",
  "height": "0.5rem",
  "width": "100%",
  "@keyframes pulse": {
    "50%": {
      "opacity": ".5"
    }
  },
  "animation": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var width = _ref2.width;
  return textLengthMap[width];
});
export var SkeletonTitleContentLoading = function SkeletonTitleContentLoading() {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "small"
    }), /*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "medium"
    })]
  });
};
export var SkeletonTitleContentListLoading = function SkeletonTitleContentListLoading() {
  return /*#__PURE__*/_jsxs(_StyledDiv30, {
    children: [/*#__PURE__*/_jsx(SkeletonTitleContentLoading, {}), /*#__PURE__*/_jsx(SkeletonTitleContentLoading, {}), /*#__PURE__*/_jsx(SkeletonTitleContentLoading, {})]
  });
};
export var SkeletonAddressLoader = /*#__PURE__*/_styled.div.withConfig({
  displayName: "skeleton-loadingcomponents__SkeletonAddressLoader",
  componentId: "sc-13h7lj6-1"
})({
  "display": "flex",
  "height": "2.5rem",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var Rectangle = /*#__PURE__*/_styled.div.withConfig({
  displayName: "skeleton-loadingcomponents__Rectangle",
  componentId: "sc-13h7lj6-2"
})({
  "marginBottom": "1rem",
  "display": "flex",
  "height": "9rem",
  "minWidth": "100%",
  "maxWidth": "15rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var CardLoaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "skeleton-loadingcomponents__CardLoaderWrapper",
  componentId: "sc-13h7lj6-3"
})({
  "display": "flex",
  "maxWidth": "15rem",
  "flexDirection": "column",
  "alignItems": "center",
  "padding": "1rem"
});

var ParagraphLoaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "skeleton-loadingcomponents__ParagraphLoaderWrapper",
  componentId: "sc-13h7lj6-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignContent": "flex-start"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv",
  componentId: "sc-13h7lj6-5"
})({
  "display": "flex",
  "width": "100%",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-y-reverse": "0",
    "marginTop": "calc(2rem * calc(1 - var(--tw-space-y-reverse)))",
    "marginBottom": "calc(2rem * var(--tw-space-y-reverse))"
  },
  "borderRadius": "1rem",
  "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 768px)": {
    "flexDirection": "column",
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-space-y-reverse": "0",
      "marginTop": "calc(0px * calc(1 - var(--tw-space-y-reverse)))",
      "marginBottom": "calc(0px * var(--tw-space-y-reverse))",
      "--tw-space-x-reverse": "0",
      "marginRight": "calc(2rem * var(--tw-space-x-reverse))",
      "marginLeft": "calc(2rem * calc(1 - var(--tw-space-x-reverse)))"
    }
  }
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv2",
  componentId: "sc-13h7lj6-6"
})({
  "position": "relative",
  "display": "flex",
  "height": "auto",
  "width": "70%",
  "alignItems": "center",
  "justifyContent": "center",
  "borderTopLeftRadius": "1rem",
  "borderBottomLeftRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))",
  "@media (min-width: 768px)": {
    "height": "6rem",
    "width": "100%",
    "borderTopLeftRadius": "1rem",
    "borderBottomLeftRadius": "0px",
    "borderTopRightRadius": "1rem"
  }
});

var _StyledSkeletonPhotoBorderedIcon = /*#__PURE__*/_styled(SkeletonPhotoBorderedIcon).withConfig({
  displayName: "skeleton-loadingcomponents___StyledSkeletonPhotoBorderedIcon",
  componentId: "sc-13h7lj6-7"
})({
  "position": "absolute",
  "left": "0.5rem",
  "bottom": "0.5rem",
  "height": "2.5rem",
  "width": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(156 163 175 / var(--tw-text-opacity))"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv3",
  componentId: "sc-13h7lj6-8"
})({
  "marginLeft": "0px !important",
  "marginTop": "0px !important",
  "width": "100%",
  "padding": "1rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv4",
  componentId: "sc-13h7lj6-9"
})({
  "marginBottom": "0.625rem",
  "height": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv5",
  componentId: "sc-13h7lj6-10"
})({
  "marginBottom": "1rem",
  "height": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv6",
  componentId: "sc-13h7lj6-11"
})({
  "marginTop": "1.5rem",
  "height": "0.375rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv7",
  componentId: "sc-13h7lj6-12"
})({
  "marginTop": "1.5rem",
  "display": "flex",
  "gap": "0.5rem"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv8",
  componentId: "sc-13h7lj6-13"
})({
  "height": "1.5rem",
  "width": "30%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv9",
  componentId: "sc-13h7lj6-14"
})({
  "height": "1.5rem",
  "width": "30%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv10",
  componentId: "sc-13h7lj6-15"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-y-reverse": "0",
    "marginTop": "calc(2rem * calc(1 - var(--tw-space-y-reverse)))",
    "marginBottom": "calc(2rem * var(--tw-space-y-reverse))"
  },
  "borderRadius": "1rem",
  "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 768px)": {
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-space-y-reverse": "0",
      "marginTop": "calc(0px * calc(1 - var(--tw-space-y-reverse)))",
      "marginBottom": "calc(0px * var(--tw-space-y-reverse))",
      "--tw-space-x-reverse": "0",
      "marginRight": "calc(2rem * var(--tw-space-x-reverse))",
      "marginLeft": "calc(2rem * calc(1 - var(--tw-space-x-reverse)))"
    }
  }
});

var _StyledDiv11 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv11",
  componentId: "sc-13h7lj6-16"
})({
  "position": "relative",
  "display": "flex",
  "height": "auto",
  "alignItems": "center",
  "gap": "1rem",
  "borderTopLeftRadius": "1rem",
  "borderBottomLeftRadius": "1rem",
  "@media (min-width: 768px)": {
    "width": "100%",
    "borderTopLeftRadius": "1rem",
    "borderBottomLeftRadius": "0px",
    "borderTopRightRadius": "1rem"
  }
});

var _StyledSkeletonPhotoBorderedIcon2 = /*#__PURE__*/_styled(SkeletonPhotoBorderedIcon).withConfig({
  displayName: "skeleton-loadingcomponents___StyledSkeletonPhotoBorderedIcon2",
  componentId: "sc-13h7lj6-17"
})({
  "height": "5rem",
  "width": "5rem",
  "paddingTop": "0.5rem",
  "paddingLeft": "0.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(156 163 175 / var(--tw-text-opacity))"
});

var _StyledDiv12 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv12",
  componentId: "sc-13h7lj6-18"
})({
  "marginBottom": "0.5rem",
  "display": "flex",
  "width": "50%",
  "flexDirection": "column",
  "gap": "0.375rem",
  "alignSelf": "flex-end"
});

var _StyledDiv13 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv13",
  componentId: "sc-13h7lj6-19"
})({
  "height": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv14 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv14",
  componentId: "sc-13h7lj6-20"
})({
  "height": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv15 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv15",
  componentId: "sc-13h7lj6-21"
})({
  "marginLeft": "0px !important",
  "marginTop": "0px !important",
  "width": "100%",
  "padding": "1rem"
});

var _StyledDiv16 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv16",
  componentId: "sc-13h7lj6-22"
})({
  "marginBottom": "0.625rem",
  "height": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv17 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv17",
  componentId: "sc-13h7lj6-23"
})({
  "marginBottom": "1rem",
  "height": "0.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv18 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv18",
  componentId: "sc-13h7lj6-24"
})({
  "marginTop": "1.5rem",
  "display": "flex",
  "gap": "0.5rem"
});

var _StyledDiv19 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv19",
  componentId: "sc-13h7lj6-25"
})({
  "height": "2rem",
  "width": "20%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv20 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv20",
  componentId: "sc-13h7lj6-26"
})({
  "height": "2rem",
  "width": "20%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv21 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv21",
  componentId: "sc-13h7lj6-27"
})({
  "height": "2rem",
  "width": "20%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv22 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv22",
  componentId: "sc-13h7lj6-28"
})({
  "marginTop": "1.5rem",
  "height": "0.5rem",
  "width": "33.333333%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv23 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv23",
  componentId: "sc-13h7lj6-29"
})({
  "boxSizing": "border-box",
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "1.25rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
});

var _StyledDiv24 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv24",
  componentId: "sc-13h7lj6-30"
})({
  "display": "flex",
  "maxWidth": "100%",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  }
});

var _StyledDiv25 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv25",
  componentId: "sc-13h7lj6-31"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "1rem"
});

var _StyledSkeletonPhotoBorderedIcon3 = /*#__PURE__*/_styled(SkeletonPhotoBorderedIcon).withConfig({
  displayName: "skeleton-loadingcomponents___StyledSkeletonPhotoBorderedIcon3",
  componentId: "sc-13h7lj6-32"
})({
  "height": "2.5rem",
  "width": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(229 231 235 / var(--tw-text-opacity))"
});

var _StyledDiv26 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv26",
  componentId: "sc-13h7lj6-33"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.5rem"
});

var _StyledDiv27 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv27",
  componentId: "sc-13h7lj6-34"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.5rem"
});

var _StyledDiv28 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv28",
  componentId: "sc-13h7lj6-35"
})({
  "display": "grid",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gap": "1rem"
});

var _StyledDiv29 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv29",
  componentId: "sc-13h7lj6-36"
})({
  "display": "flex",
  "height": "1rem",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv30 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "skeleton-loadingcomponents___StyledDiv30",
  componentId: "sc-13h7lj6-37"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem",
  "paddingTop": "1rem"
});